import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import SpaceSelectorItem from './SpaceSelectorItem';
import * as selectors from '../../../../../../core/selectors/spaces';

const spaceSelector = (state, { spaceId }) =>
  selectors.spaceById(selectors.spacesData(state), spaceId);

const mapStateToProps = createSelector(spaceSelector, (space) => ({
  name: space.name,
  avatar: space.avatar,
  hasActivity: space.unread,
}));

const SpaceSelectorItemContainer = connect(mapStateToProps)(SpaceSelectorItem);

export default SpaceSelectorItemContainer;
